import {Component, Input} from "@angular/core";
import { Router } from '@angular/router';
import {TourApplication, TourTimetable} from "../../service/tour-application/tour-application";
import {TourApplicationService} from "../../service/tour-application/tour-application.service";
import {privacyText} from "../../privacy/privacy.component";
import {termsText} from "../../terms/terms.component";
import {environment} from "../../../environments/environment";
import * as moment from "moment"

@Component({
  selector: 'app-tour',
  templateUrl: 'tour.component.html',
  styleUrls: ['tour.component.scss'],
  providers: [TourApplicationService]
})
export class TourComponent {
  location: string;
  locationTxt: string;
  terms: string;
  complete: boolean;

  timeValues = {
    TEN: { value: 10, text:'10:00~11:00'},
    TEN_HALF: { value: 10.5, text:'10:30~11:30'},
    ELEVEN: { value: 11, text:'11:00~12:00'},
    ELEVEN_HALF: { value: 11.5, text:'11:30~12:30'},
    FOURTEEN: { value: 14, text:'14:00~14:30'},
    FOURTEEN_HALF: { value: 14.5, text:'14:30~15:30'},
    FIFTEEN: { value: 15, text:'15:00~16:00'},
    FIFTEEN_HALF: { value: 15.5, text:'15:30~16:30'},
    SIXTEEN: { value: 16, text:'16:00~17:00'},
    SIXTEEN_HALF: { value: 16.5, text:'16:30~17:30'},
  };

  timetables: TourTimetable[];
  enableDays: string[];

  selectedDay: string;
  enableTimetables: TourTimetable[];

  en: boolean;

  constructor(private applicationService: TourApplicationService, private router: Router) {
    this.en = environment.english;

    this.location = router.url.split('/')[1]
    this.locationTxt = this.location === 'seongsu' ? '성수 시작점' : '서울숲점'

    this.initTimeTables();

    this.terms = '<h4><(사)루트임팩트 - 헤이그라운드 투어 관련> 개인정보 처리방침</h4>' + termsText;
  }

  initTimeTables() {
    this.applicationService.getTimetable(this.location).subscribe(
      timetables => {
        let today = moment()
        let date = today.format('YYYY-MM-DD')
        let hour = today.format('HH')

        this.timetables = timetables.filter(o => {
          return (o.date === date && this.timeValues[o.time].value > hour ) || (o.date !== date && o.peopleCount < 10)
        });

        this.enableDays = Array.from(new Set(this.timetables.map(timetable => timetable.date))).sort();
      }
    );
  }

  private _email;
  private email_provider = [
    '@naver.com',
    '@gmail.com',
    '@hanmail.com',
    '@Hotmail.com',
    '@nate.com',
    '@yahoo.com',
  ]
  email_list: string[] = []
  get email(): string { return this._email; }
  @Input()
  set email(val: string) {
    this._email = val;
    if(val.length && val.split('@').length === 1) {
      this.email_list = this.email_provider.map(o => val+o)
    } else {
      this.email_list = []
    }
  }
  onClickEmailItem(item){
    this.email = item;
  }

  onNumberCheck(phone: string) {
    return phone.replace(/[^0-9\.]+/g, '');
  }

  onSelectedDate(date: string) {
    this.selectedDay = date;
    this.enableTimetables = this.timetables.filter(timetable => this.selectedDay == timetable.date)
      .sort((a, b) => this.timeValues[a.time].value - this.timeValues[b.time].value);
  }

  extraPeople: number = 10;
  onSelectHour(table) {
    this.extraPeople = 10 - table.peopleCount;
  }

  /** 투어신청 완료시 */
  agree: boolean = false;

  getOffsetTop(el): number { var top = 0; if (el.offsetParent) { do { top += el.offsetTop; } while (el = el.offsetParent); return top; } }

  onApply(application: TourApplication) {
    application.timetable = this.timetables.find(timetable => timetable.id == application['timetable.id']);
    application.phone = this.onNumberCheck(application.phone);
    application.location = {key: this.location}

    if (!application.timetable) {
      window.scrollTo( 0, -200 + this.getOffsetTop(document.getElementsByClassName('timetable')[0]) );
      window.alert('투어 희망일 및 시간을 선택해 주세요.');
      return;
    } else if (!application.name) {
      window.scrollTo( 0, -200 + this.getOffsetTop(document.getElementsByName('name')[0]) );
      window.alert('이름을 입력해 주세요.');
      return;
    } else if (!application.phone) {
      window.scrollTo( 0, -200 + this.getOffsetTop(document.getElementsByName('phone')[0]) );
      window.alert('휴대폰 번호를 입력해 주세요.');
      return;
    } else if (!application.email) {
      window.scrollTo( 0, -200 + this.getOffsetTop(document.getElementsByName('email')[0]) );
      window.alert('이메일 주소를 입력해 주세요.');
      return;
    } else if (!application.numOfPeople) {
      window.scrollTo( 0, -200 + this.getOffsetTop(document.getElementsByName('numOfPeople')[0]) );
      window.alert('신청 인원을 선택해 주세요.');
      return;
    } else if (!application.etc) {
      window.scrollTo( 0, -200 + this.getOffsetTop(document.getElementsByName('etc')[0]) );
      window.alert('신청 사유를 입력해 주세요.');
      return;
    } else if (!this.agree) {
      window.alert('약관 및 개인정보정책에 동의해 주세요.');
      return;
    }

    this.applicationService.apply(application).subscribe(
      application => {
        application.complete = true;
        sessionStorage.removeItem('__hey_tourList');
        sessionStorage.setItem('__hey_tourDetail', JSON.stringify(application));
        this.router.navigate(['/tour',application.id])
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/space/tour/tour.component.ts